import React, { useState, useEffect, useRef } from "react"
import { App as AntApp, ConfigProvider } from "antd"
import viVN from "antd/locale/vi_VN"
import { StoreProvider, useStore } from "./components/ui"
import Routes from "./components/Router"
import "./taiwind.css"
import "./Base.css"

const apiBase = process.env.REACT_APP_API_DOMAIN || "/api/v1"

function AppContent() {
  const { setAuth, authLoaded } = useStore()
  const [authChecked, setAuthChecked] = useState(false)
  const authCheckDone = useRef(false)

  useEffect(() => {
    if (authCheckDone.current) return
    authCheckDone.current = true

    // Check if user is authenticated by calling /auth/me/ with cookies
    fetch(`${apiBase}/auth/me/`, {
      credentials: "include"
    })
      .then(res => {
        if (res.ok) return res.json()
        throw new Error("Not authenticated")
      })
      .then(data => {
        // /me/ returns { user: {...}, permissions: [...], is_super_admin: true }
        // user.full_name might be empty, use root full_name instead
        const authData = {
          user: {
            ...data.user,
            full_name: data.full_name || data.user?.full_name || data.user?.email
          },
          permissions: data.permissions,
          is_super_admin: data.is_super_admin,
          token: "cookie-auth"
        }
        setAuth(authData)
      })
      .catch((err) => {
        console.log("Auth check failed:", err)
        // Not authenticated - this is normal, stay on login
      })
      .finally(() => {
        setAuthChecked(true)
      })
  }, [setAuth])

  // Show loading while checking auth
  if (!authChecked || !authLoaded) {
    return (
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        height: "100vh",
        background: "#f0f0f0"
      }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ 
            width: 40, 
            height: 40, 
            border: "4px solid #0f766e", 
            borderTopColor: "transparent",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 16px"
          }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <p>Đang tải...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="App">
      <ConfigProvider
        locale={viVN}
        theme={{
          token: {
            colorPrimary: "#0f766e",
            borderRadius: 8
          }
        }}
      >
        <AntApp>
          <Routes />
          <div id="modal-root"></div>
        </AntApp>
      </ConfigProvider>
    </div>
  )
}

function App() {
  return (
    <StoreProvider>
      <AppContent />
    </StoreProvider>
  )
}

export default App
